const topics = [
  { label: '#庆余年2大结局', count: '128万讨论', hot: true },
  { label: '#2026暑期档', count: '96万讨论', hot: true },
  { label: '#流浪地球3', count: '87万讨论', hot: true },
  { label: '#国产悬疑剧崛起', count: '65万讨论', hot: false },
  { label: '#王家卫繁花美学', count: '58万讨论', hot: false },
  { label: '#免费在线看剧平台', count: '52万讨论', hot: false },
  { label: '#与凤行二搭', count: '47万讨论', hot: false },
  { label: '#动漫新番推荐', count: '41万讨论', hot: false },
  { label: '#高分纪录片', count: '36万讨论', hot: false },
  { label: '#狂飙经典台词', count: '33万讨论', hot: false },
  { label: '#周末观影指南', count: '29万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600">加入讨论，发现更多志同道合的影迷朋友。</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topics.map((item, i) => (
            <div
              key={i}
              className={`group flex items-center gap-2.5 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-300 ${
                item.hot
                  ? 'bg-primary-100 border-primary-200 hover:bg-primary-200'
                  : 'bg-background-50 border-background-200 hover:border-primary-200/50'
              }`}
            >
              {item.hot && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-accent-500"></i>
                </div>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${item.hot ? 'text-primary-700' : 'text-foreground-700'}`}>
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}